/**
 * Models a chart
 */

import Chart from "./chart";
import Member from "./member";
import Provider from "./provider";
import StringKeyValueCollection from "../../collections/key-string-value";
import NumericKeyValueCollection from "../../collections/key-numeric-value";
import ReviewersList from "../../collections/chart-reviews/reviewers/selectable";
import RetrievalStatusNAReasonsCollection from "../../collections/chart-reviews/na-reason-codes";
import MemberCategories from "../../models/chart-reviews/member-category";

const Model = Chart.extend({
  namedAttributes: {
    projectName: String,
    selectedMember: Member,
    selectedProvider: Provider,
    projectIdList: NumericKeyValueCollection,
    reviewersList: ReviewersList,
    retrievalStatusList: StringKeyValueCollection,
    retrievalStatusNAReasonList: RetrievalStatusNAReasonsCollection,
    statusList: StringKeyValueCollection,
    chartAttributeList: NumericKeyValueCollection,
    note: String,
    diagMinDate: String,
    diagMaxDate: String,
    memberCategories: MemberCategories,
    diagnosisAttributesList: StringKeyValueCollection,
  },

  initialize() {
    this.listenTo(
      this,
      "change:retrievalStatus",
      this._onRetrievalStatusChange
    );
    this.listenTo(
      this,
      "change:retrievalStatusNAReason",
      this._onRetrievalStatusReasonCodeChange
    );
    this.listenTo(
      this,
      "change:retrievalStatusNAReason",
      this._markActiveRetrievalStatusNAReason
    );

    this.set({
      projectName: null,
      selectedMember: null,
      selectedProvider: null,
      projectIdList: new NumericKeyValueCollection(),
      reviewersList: new ReviewersList(),
      retrievalStatusList: new StringKeyValueCollection(),
      retrievalStatusNAReasonList: new RetrievalStatusNAReasonsCollection(),
      statusList: new StringKeyValueCollection(),
      chartAttributeList: new NumericKeyValueCollection(),
      note: null,
      memberCategories: new MemberCategories(),
      diagnosisAttributesList: new StringKeyValueCollection(),
    });
  },

  _onRetrievalStatusChange(model, value) {
    if ("NOT_AVAILABLE" !== value) {
      this.set({ retrievalStatusNAReason: null });
    }
  },

  _onRetrievalStatusReasonCodeChange(model, value) {
    let reasonCode = null;
    if ("NOT_AVAILABLE" === this.get("retrievalStatus")) {
      reasonCode = value;
    }
    this.set({ retrievalStatusNAReason: reasonCode });
  },

  _markActiveRetrievalStatusNAReason(model, value) {
    const coll = this.get("retrievalStatusNAReasonList");
    coll.map((model) => {
      const match = value === model.getKey();
      model.setChecked(match);
    });

    this.set({ retrievalStatusNAReasonList: coll });
  },
});

export { Model as default };
